import { IConfiguration } from "@app/config/getConfig.interfaces";
import ProductionConfig from "@app/config/production";

const StagingConfig: Omit<IConfiguration, "supportedBrackets"> = {
  ...ProductionConfig,
  environment: "staging",
  urls: {
    ...ProductionConfig.urls,
    app: "https://rauli.turator.fi",
  },
  version: process.env.REACT_APP_CI_COMMIT_TAG ?? "staging",
};

export default StagingConfig;
